module.exports = __webpack_public_path__ + "img/17.9964f7bc.jpg";